import React, { useEffect, useState, Fragment } from 'react'
import { Modal, Form, Input, Row, Col, Select, Table, Descriptions  } from 'antd'
import moment from 'moment'
import styles from './index.less'
const { TextArea } = Input
const { Search } = Input;
const {Option}= Select

const ProductDetail = ({data,...modalProps}) => {

  useEffect(() => {
    // console.log(data)
  }, [data])

  const handleOk = () => {

  }

  return (
    <Modal {...modalProps}>
        <Descriptions>
          <Descriptions.Item label="商品分类">{(data.categories || []).map(_ => _.name).join("/")}</Descriptions.Item>
          <Descriptions.Item label="商品编码">{data.code}</Descriptions.Item>
          <Descriptions.Item label="商品名称">{data.name}</Descriptions.Item>
          <Descriptions.Item label="商品价格">{data.price}</Descriptions.Item>
          <Descriptions.Item label="服务时长">{data.serviceDuration}</Descriptions.Item>
          <Descriptions.Item label="服务频次">{data.quantity}</Descriptions.Item>
          <Descriptions.Item label="服务类型">首诊</Descriptions.Item>
          <Descriptions.Item label="产品描述">{data.comment}</Descriptions.Item>
        </Descriptions>
    </Modal>
  )
}
export default ProductDetail
